import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { PackageInfo } from './package-info.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar-tile',
  templateUrl: './sidebar-tile.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarTileComponent {

  private readonly router = inject(Router);


  @Input()
  set packageInfo(value: PackageInfo | null) {
    this.loading = false;
    this._packageInfo = value;

    if(this._packageInfo === null) {
      this.status = 'error';
    } else {
      this.status = 'info';
    }
  }

  _packageInfo: PackageInfo | null = null;

  @Input()
  public inactivePackages: PackageInfo[] = [];

  @Input()
  public mode: 'desktop' | 'mobile' = 'desktop';

  status: 'warning' | 'error' | 'info' = 'error';

  public loading = true;

  calculateProgressPercentage(): number {
    if(this._packageInfo?.state === null) {
      return 100;
    }

    // Always use 100 as max for progress bar calculation
    const maxCards = 100;
    const percentage = (this._packageInfo?.state / maxCards) * 100;
    // Cap at 100% even if state exceeds max
    return Math.min(percentage, 100);
  }

  getProgress(): number {
    return this._packageInfo?.state;
  }

  getMax(): number {
    return this._packageInfo?.max;
  }

  getProgressBarColor(): 'red' | 'yellow' | 'primary' {
    const state = this._packageInfo?.state;
    if (state === null || state === undefined) {
      return 'primary';
    }

    if (state < 10) {
      return 'red';
    } else if (state < 40) {
      return 'yellow';
    }
    return 'primary';
  }

  getTotalInactiveCards(): number {
    return this.inactivePackages.reduce((sum, pkg) => sum + (pkg.state || 0), 0);
  }

  hasInactivePackages(): boolean {
    return this.inactivePackages && this.inactivePackages.length > 0;
  }

  getIconClass(): string {
    switch(this.status){
      case 'error':
        return 'pi pi-exclamation-triangle';
      case 'warning':
        return 'pi pi-exclamation-circle';
      case 'info':
        return 'pi pi-check-circle';
    }
  }
}
